export default "__VITE_ASSET__0b4f6672__"